import { Inject, Injectable } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { FIREBASE_APP } from '../injections/firebase-app';
import { AgentMergeRequestModel } from '@ag-common-lib/lib/models/functions/merge-tool/agent-merge-request.model';
import { DataService } from 'ag-common-svc/lib/services/data.service';

@Injectable({
  providedIn: 'root',
})
export class AgentMergeRequestsService extends DataService<AgentMergeRequestModel> {
  private readonly collectionPath = 'merge-requests';

  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    super(fireBaseApp);
    super.setCollection(this.collectionPath);
  }
}
